import { TrackingHandler } from '../TrackingHandler';
import { Listener } from './Listener';
export class LocalStorageListener extends Listener {
    cookiesAccepted = false;
    visitorTimestamp;
    constructor() {
        super();
        this.visitorTimestamp = window.localStorage.getItem('visitorTimestamp')
            ? parseInt(window.localStorage.getItem('visitorTimestamp'))
            : window.trackingHandler.viewTimestamp;
    }
    setConsent(eventId, essential, functional, marketing) {
        if (!functional && this.cookiesAccepted) {
            this.clearLocalStorage();
        }
        if (functional && !this.cookiesAccepted) {
            this.persistLocalStorage();
        }
        this.cookiesAccepted = functional;
    }
    setCustomer(eventId) {
        if (this.cookiesAccepted) {
            window.localStorage.setItem('customer', '1');
        }
    }
    clearLocalStorage() {
        window.localStorage.clear();
    }
    persistLocalStorage() {
        const trackingHandler = TrackingHandler.getInstance();
        window.localStorage.setItem('trackingData', JSON.stringify(trackingHandler.getVisitorTrackingData()));
        window.localStorage.setItem('visitorTimestamp', this.visitorTimestamp.toString());
    }
}
